import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-folder",
  "use": "icon-folder-usage",
  "viewBox": "0 0 100 100",
  "content": "<symbol viewBox=\"0 0 100 100\" id=\"icon-folder\">\n  <path d=\"M 20 10 H 80 V 80 H 20 L 20 10 Z\" fill=\"none\" stroke-width=\"10\" />\n  <path d=\"M 20 10 H 50 L 50 30 H 80\" fill=\"none\" stroke-width=\"10\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol